module.exports = __webpack_public_path__ + "img/FilterAltOffOutlined.ff7f72c3.svg";